// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};
  
  /* start-boost-custom */
  /* #boost-83883: Custom button in Instant Search */
  InstantSearchResult.prototype.afterRender = function() {
    if (!this.$instantSearchResult) return;
    if(window.location.href.indexOf('.com') > -1) {
      this.$instantSearchResult.append('<li class="boost-pfs-search-suggestion-header-help boost-pfs-search-suggestion-header"><button onClick="PREEZIE_GUIDE.openPrzCtaGuide()">Help me find a Knife</button></li>')
    }
    
  }
  /* end-boost-custom */
})();